import React, { type SyntheticEvent, useMemo } from "react";
import useGetBuildSpinnerFrame from "../../../../hooks/shared/spin/useGetBuildSpinnerFrame";
import { BnbLabel } from "../../../../utils/labels";
import * as Flex from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Flex";
import { ImageFluid } from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Image";
import { type BuildAndBuyDispatchType, useBnbSelector } from "../../../../redux/store";
import { NavStep } from "../../../../../shared-logic/utils/Navigation";
import { generateImageSet } from "../../../../utils/typedUtils";
import * as Styles from "../nav/styles/BasketButton";
import Basket from "./Basket";
import BasketHeader from "./content/BasketHeader";
import BasketFinanceTogglePanel from "../basket-financetoggle-panel/BasketFinanceTogglePanel";
import { useDisableBodyScroll } from "../../../../../../../common-deprecated/hooks";
import { MAIN_NAV_CLASSNAME_TOYOTA } from "../../../../../../../common-deprecated/constants";
import { showMobileBasket } from "../../../../../../../common-deprecated/redux/actions/UtilActions";
import Icon from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import UnsetZIndexHelper from "../../../../../../../common-deprecated/components/UnsetZIndexHelper";
import { useDispatch } from "../../../../../../../shared-logic/redux/store";

const MobileBasket = (): JSX.Element => {
    const dispatch = useDispatch<BuildAndBuyDispatchType>();
    const step = useBnbSelector((state) => state.navigation.step);
    const car = useBnbSelector((state) => state.car);

    useDisableBodyScroll();

    const { getImage, cacheKey } = useGetBuildSpinnerFrame(false);
    const image = useMemo(() => {
        return generateImageSet(
            (width: number, height: number) => getImage(width, height, 2, { bgColour: "", padding: 0 }),
            800,
            460,
        );
    }, [cacheKey]);

    const closeBasket = (event: SyntheticEvent): void => {
        event.preventDefault();
        dispatch(showMobileBasket(false));
    };

    return (
        <Styles.MobileBasket>
            {/* component only renders when it is actually visible (for performance reasons), so no disabled flag is needed */}
            <UnsetZIndexHelper enabled selectors={[MAIN_NAV_CLASSNAME_TOYOTA]} />
            <div className="or-scroll-target payment-switch" />
            <Styles.MobileBasketHeader>
                <Styles.BasketTitle>
                    <BnbLabel label="basketYourModel" params={{ name: car.model.webtitleSectionName }} />
                </Styles.BasketTitle>

                <Styles.CloseMobileBasket onClick={closeBasket}>
                    <Icon variant="close" />
                </Styles.CloseMobileBasket>
            </Styles.MobileBasketHeader>

            {step === NavStep.Summary && (
                <>
                    <Styles.BasketTitleWrapper>
                        <Flex.Col mt={{ _: 0, lg: 3 }}>
                            <BasketHeader />
                        </Flex.Col>
                        <ImageFluid src={image.src} srcSet={image.srcset} sizes="" draggable={false} alt="" />
                    </Styles.BasketTitleWrapper>
                </>
            )}

            {step === NavStep.Customize && <BasketFinanceTogglePanel />}

            <Basket attached={step === NavStep.Customize} />
        </Styles.MobileBasket>
    );
};

export default MobileBasket;
